import { useState } from "react";

import useInterval from "core/hooks/useInterval";


export default function useTimer(seconds = 30) {
	const [remaining, setRemaining] = useState(seconds);

	useInterval(() => {
		setRemaining((t) => t <= 1 ? 0 : t - 1);
	}, remaining > 0 ? 1000 : null);

	const reset = () => setRemaining(seconds);

	return { remaining, expired: remaining === 0, reset };
}